import font from './fonts.json'
import logo from './logo.json'
import centeredLayout from './centeredLayout.js'
import pdf from 'pdfmake'
pdf.vfs = {
    "siemreap.ttf": font.siemreap,
    "moul.ttf": font.moul,
    "battambang.ttf": font.battambang,
    "battambang_bold.ttf": font.battambang_bold,
    "tacteing.ttf": font.tacteing,
}
pdf.fonts = {
    siemreap: {
        normal: "siemreap.ttf",
        bold: "siemreap.ttf",
    },
    moul: {
        normal: "moul.ttf",
        bold: "moul.ttf",
    },
    battambang: {
        normal: "battambang.ttf",
        bold: "battambang_bold.ttf",
    },
    tacteing: {
        normal: "tacteing.ttf",
    },
}
export default {
    pageMargins: [10, 20, 10, 20],
    pageOrientation: 'portrait',
    centeredLayout: centeredLayout,
    fontSize: 12,
    pageSize: {
        width: 226,
        height: 'auto'
    },
    load(content) {
        let pdfPage = {
            defaultStyle: {
                font: "battambang",
                fontSize: this.fontSize,
            },
            pageSize: this.pageSize,
            pageMargins: this.pageMargins,
            pageOrientation: this.pageOrientation,
            content: content,
            images: {
                logo: logo.base64,
            },
        }
        pdf.createPdf(pdfPage).open()
        pdfPage = {}
    }
}
